import { render, staticRenderFns } from "./videoModal.vue?vue&type=template&id=410bed97&scoped=true&"
import script from "./videoModal.vue?vue&type=script&lang=js&"
export * from "./videoModal.vue?vue&type=script&lang=js&"
import style0 from "./videoModal.vue?vue&type=style&index=0&id=410bed97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410bed97",
  null
  
)

export default component.exports